import ComparisonModulesRenderer from '@/components/_rebrand/craft/ComparisonModulesRenderer';
import { IndustryPathsQuery, IndustryQuery, IndustryQueryVariables } from '@/graphql';
import IndustryQueryDocument from '@/graphql/queries/Industry.gql';
import IndustryPathsQueryDocument from '@/graphql/queries/IndustryPaths.gql';
import ModularPageLayout from '@/layouts/ModularPageLayout';
import { getPageProps } from '@/lib/craft-page';
import CraftClient from '@/lib/graphql';
import { getStaticPagePaths, getStaticPageProps } from '@/lib/next';
import { ModularPageProps, ParseModuleBuilderPropsInput, parseModuleBuilderProps } from '@/modules/ModuleBuilder';
import MasterTemplate from '@/templates/MasterTemplate';

const Industry: PageTemplate<IndustryQuery | ModularPageProps> = (props) => {
  if ('modularPageProps' in props) {
    return <ModularPageLayout props={props.modularPageProps} />;
  }

  const entry = 'entry' in props ? props.entry : null;
  const isRebrandModularEntry = entry?.__typename === 'industries_rebrandModular_Entry';

  if (entry && isRebrandModularEntry) {
    return <ComparisonModulesRenderer modules={entry.comparisonModules} />;
  }

  return null;
};

Industry.template = (props) => {
  const entry = 'entry' in props ? (props as IndustryQuery).entry : null;
  const isRebrandModularEntry = entry?.__typename === 'industries_rebrandModular_Entry';

  return <MasterTemplate {...props} className={isRebrandModularEntry ? 'mt-0' : ''} />;
};

export default Industry;

export const getStaticPaths = getStaticPagePaths('industries', async (context) => {
  const client = new CraftClient();

  const data = await client.request<IndustryPathsQuery>(IndustryPathsQueryDocument);

  const paths =
    data.entries?.map((path) => ({
      params: {
        slug: path?.slug!,
      },
    })) || [];

  return {
    paths,
    fallback: 'blocking',
  };
});

export const getStaticProps = getStaticPageProps<{}, { slug: string }>(
  (params) => `industries/${params?.slug}`,
  async ({ client, context: { params } }) => {
    const pageProps = await getPageProps<IndustryQuery, IndustryQueryVariables>({
      pathPrefix: '/industries',
      queryDocument: IndustryQueryDocument,
      client,
      variables: {
        slug: params?.slug,
      },
    });

    if (!pageProps?.entry) {
      return { notFound: true };
    }

    if (pageProps.entry.__typename === 'industries_modular_Entry') {
      return {
        props: parseModuleBuilderProps(pageProps as ParseModuleBuilderPropsInput)
      }
    }

    return {
      props: {
        ...pageProps,
      },
    };
  },
);
